import axios from "../lib/axios";
import { baseUrl } from "./api-routes";

export const performRequest = (
  method = "GET",
  url,
  params = {},
  auth,
  user,
  page,
  headers = {},
  fullUrl = false,
  responseType = "json", // Default response type is 'json'
  timeout = 0,
) => {
  const body = method.toLowerCase() === "get" ? "params" : "data";
  const urlParam = page ? `?page=${page}` : "";

  const requestHeaders = Object.assign(headers, {
    Accept: "application/json",
  });

  if (process.env.REACT_APP_ENV === "staging") {
    requestHeaders["X-Staging-Access"] = process.env.REACT_APP_STAGING_TOKEN;
  }

  const config = {
    method,
    url: fullUrl ? url : `${url}${urlParam}`,
    timeout,
    baseURL: baseUrl,
    [body]: params,
    withCredentials: true,
    credentials: true,
    headers: requestHeaders,
    responseType, // Set the response type
  };

  const response = axios.request(config);
  return response;
};

export default performRequest;
